/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectUserMails, userMailsActions } from "Features/utils";
import { Button, Input } from "Shared/ui";

import "../auth.scss";
import { authActions } from "Features/auth";

export const ConfirmEamailPage = () => {
	const dispatch = useDispatch();
	const mails = useSelector(selectUserMails.list);
	const nextMail = useSelector(selectUserMails.countdown);
	const [seconds, setSeconds] = useState(0);
	const [newEmail, setNewEmail] = useState("");
	const [tick, setTik] = useState(false);

	useEffect(() => {
		init();
	}, []);

	function init() {
		dispatch(authActions.check());
		dispatch(userMailsActions.get());
	}

	useEffect(() => {
		const secondCount = calcCountdown();

		if (secondCount !== seconds) {
			setSeconds(secondCount);
		}
		setTimeout(() => setTik(!tick), 1000);
	}, [tick]);

	function calcCountdown() {
		if (nextMail) {
			return Math.max(0, Math.ceil((new Date(nextMail) - new Date()) / 1000));
		}
		return 0;
	}

	function sendMail() {
		if (seconds === 0) {
			const sendEmail = newEmail ? newEmail : mails[0]?.address;
			dispatch(userMailsActions.sendMail(sendEmail));
		}
	}

	function logout() {
		dispatch(authActions.remove());
	}

	return (
		<div className="auth">
			<div className="auth__container auth__container_w500">
				<div className="auth__block mb-30">
					<div className="auth__block-text mb-10">
						<span className="auth__block-text_big">Confirmation</span>
					</div>
					<div className="auth__block-container mb-30">
						<div style={{ maxWidth: 300 }} className="auth__block-text auth__block-text_small">
							We have sent you an e-mail. Please, confirm your e-mail address
						</div>
					</div>
					<div className="auth__block-container">
						<Input outValue={newEmail ? newEmail : mails[0]?.address} setOutValue={setNewEmail} />
					</div>
				</div>
				<Button text="Сheck" onClick={init} />
				<div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
					<Link disabled onClick={sendMail}>
						{seconds === 0 ? "Send again" : `Repeat in ${seconds} s`}
					</Link>
					<Link disabled onClick={logout}>
						{"Log out"}
					</Link>
				</div>
			</div>
		</div>
	);
};
